import React, {
  PropsWithChildren,
  useRef,
  useEffect,
  useCallback,
} from 'react';

import * as Styles from './styles';

export type DropDownListProps = {
  id: string | number;
  title: string;
  href: string;
};

type DropDownProps = {
  open: boolean;
  items: DropDownListProps[];
  onClose(item: boolean): void;
};

export default function DropDown({
  children,
  open,
  items,
  onClose,
}: PropsWithChildren<DropDownProps>) {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const pageClickEvent = useCallback(
    (e: MouseEvent) => {
      if (
        dropdownRef.current !== null &&
        !dropdownRef.current.contains(e.target as HTMLDivElement)
      ) {
        onClose(!open);
      }
    },
    [onClose, dropdownRef, open],
  );

  useEffect(() => {
    if (open) {
      window.addEventListener('click', pageClickEvent);
    }
    return () => {
      window.removeEventListener('click', pageClickEvent);
    };
  }, [open, pageClickEvent]);

  return (
    <Styles.Container>
      {children}
      {open && items.length > 0 && (
        <Styles.List ref={dropdownRef}>
          {items.map((item, index) => (
            <li key={`${item.title}-${String(index)}`}>
              <Styles.Button color="transparent" href={item.href}>
                {item.title}
              </Styles.Button>
            </li>
          ))}
        </Styles.List>
      )}
    </Styles.Container>
  );
}
